@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_sys

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.engineservice.ServiceApi
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.GlobalManager
import org.example.project.service.ZustandManager
import org.example.project.service.currentSaveArt
import org.example.project.utils.All

@Composable
fun SYSSupportAuskunft(art: String = currentSaveArt()) {
    val supportLiveVersion = GlobalManager.jsonDomainVersion("support")
    var tickets by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzteFilter by remember { mutableStateOf<Map<String, String>?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(art, supportLiveVersion) {
        tickets = letzteFilter?.let { filters ->
            runCatching { ServiceApi.searchSupport("all", filters).sortedBy { it.id.toIntOrNull() ?: 0 } }
                .getOrDefault(emptyList())
        }.orEmpty()
    }

    val headers = listOf(
        "ID",
        "Ticketnummer",
        "Zustand",
        "KI Erfolgreich",
        "FirmenId",
        "Firma",
        "Mitarbeiter",
        "Personalnummer",
        "Supportart",
        "Betroffener Screen",
        "KI Auswahl",
        "Bearbeitet von",
        "Bearbeitet am",
        "Bearbeitet um"
    )

    TabularScreen(
        screenKey = "SupportAuskunftScreen_${art}",
        rollenKey = "SupportAuskunftScreen_${art}",
        title = "Supportverwaltung (${art})",
        headers = headers,
        data = tickets.map { ticket ->
            ticket.id to buildList {
                val mitarbeiter = "${ticket.vorname} ${ticket.nachname}".trim()
                add(ticket.id)
                add(ticket.ticketnummer)
                add(ZustandManager.Support.textFor(ticket.zustand))
                add(if (ticket.problemGeloest) "Ja" else "Nein")
                add(ticket.firmenId)
                add(ticket.firma)
                add(mitarbeiter)
                add(ticket.personalnummer)
                add(ticket.supportart)
                add(ticket.screenKey.ifBlank { ticket.ticketgrund })
                add(ticket.kiAuswahl)
                add(ticket.bearbeitetVon)
                add(ticket.bearbeitetAm)
                add(ticket.bearbeitetUm)
            }
        },
        editable = false,
        hardReadOnly = true,
        includeMetadata = true,
        nonEditableCols = headers.toSet(),
        allowCreate = false,
        allowDelete = false,
        onSearchWithFilters = { filters ->
            scope.launch {
                letzteFilter = filters
                tickets = runCatching {
                    ServiceApi.searchSupport("all", filters).sortedBy { it.id.toIntOrNull() ?: 0 }
                }.getOrDefault(emptyList())
            }
        },
        dropdownOptions = emptyMap(),
        createRow = { _ -> List(headers.size) { "" } },
        onCommit = { _ -> },
        onDeleteRows = { _ -> },
        onRowClick = { _ -> }
    )
}
